import { enUS, fi, sv } from "date-fns/locale";
import i18n from "../../i18n";

const getLocale = () => {
  const UILanguage = i18n.language;

  switch (UILanguage) {
    case "sv":
      return sv;
    case "en-GB":
    case "en-US":
    case "en":
      const locale = {
        ...enUS,
        code: "en",
      };

      return locale;
    default:
      return fi;
  }
};

export default getLocale;
